<template>
  <section>
    <logged-in-header />
    <changeLeadersPanel />
    <empower-footer />
    <WhatsApp />
  </section>
</template>

<script>
import loggedInHeader from "../../components/commom/LoggedInHeader";
import changeLeadersPanel from "../../components/organization/ChangeLeadersPanel";
import empowerFooter from "../../components/commom/EmpowerFooter";
import WhatsApp from "../../components/commom/WhatsApp";

export default {
  name: "ChangeLeaders",
  components: {
    loggedInHeader,
    changeLeadersPanel,
    empowerFooter,
    WhatsApp
  }
};
</script>
